import React from "react";
import { Link } from "react-router-dom";
import { MdDangerous } from "react-icons/md";
import { TiWarningOutline } from "react-icons/ti";
import { GoInfo } from "react-icons/go";
import classNames from "classnames";
import usePortal from "../../contexts/PortalContext";
import { PortalBannerType } from "../../__generated__/api";
import Styles from "./Banner.module.scss";
import { useTheme } from "../../contexts/Theme";
import Alert, { AlertVariantType } from "../theme/alert/Alert";

const FEATURE_DISPLAY_BANNER = "frontend.trial.banner";

const STYLES = {
    [PortalBannerType.Danger]: {
        icon: <MdDangerous />,
        className: "bg-danger text-white",
        variant: "danger" as AlertVariantType,
    },
    [PortalBannerType.Warning]: {
        icon: <TiWarningOutline />,
        className: "bg-danger-light text-white",
        variant: "warning" as AlertVariantType,
    },
    [PortalBannerType.Info]: {
        icon: <GoInfo />,
        className: "bg-blue-dark text-white",
        variant: "primary" as AlertVariantType,
    },
};

export default function Banner() {
    const { banner, featureFlags } = usePortal();
    const theme = useTheme();

    const showBanner = featureFlags.has(FEATURE_DISPLAY_BANNER)
    && banner?.expirationDate
    && banner?.expirationDate.getTime() > Date.now();

    if (!banner || !showBanner) {
        return null;
    }

    const type = banner.type ?? PortalBannerType.Info as PortalBannerType;

    const style = STYLES[type];
    return (
        <Link
            className={classNames(
                theme.isV3 ? "" : `top-0 w-100 d-block text-center p-2 text-decoration-none`,
                theme.isV3 ? "" : style.className,
                Styles["banner-container"],
            )}
            to={banner.linkUrl as string}
        >
            {theme.isV3 ? (
                <Alert prefixIcon={style.icon} variant={style.variant}>
                    {banner.message}
                </Alert>
            ) : (
                <>
                    {style.icon}
                    {" "}
                    {banner.message}
                </>
            )}

        </Link>
    );
}
